import { useEffect } from "react";
import { useAuth } from "@cayuse/shared-react.utils.auth";

export const useAuthenticationRequired = () => {
	const { loading, isAuthenticated, loginWithRedirect } = useAuth();

	useEffect(() => {
		if (loading || isAuthenticated) {
			return;
		}

		const loginAndRedirect = async () => {
			const location = window.location.href;

			await loginWithRedirect({
				appState: { targetUrl: location }
			});
		};

		loginAndRedirect();
	}, [ loading, isAuthenticated, loginWithRedirect ]);

	return { loading, isAuthenticated };
};

export default useAuthenticationRequired;
